import { getUrlApi } from '../utilities/util';
import ApiHandler from './ApiHandlers/ApiHandler';

export const baseURL = String(getUrlApi());

type ListGroupsParams = {
  companyId?: string;
};

export type UpdateGroupPayload = {
  id: string;
  name: string;
  description: string;
  color: string;
};

export default class GroupApi {
  static async ListGroups(params?: ListGroupsParams): Promise<any> {
    const companyId = params?.companyId?.trim();

    if (companyId) {
      const encoded = encodeURIComponent(companyId);
      return ApiHandler(baseURL).get(`/group/filter?CompanyId=${encoded}`);
    }

    // Fallback to legacy endpoint when no company context is provided
    return ApiHandler(baseURL).get("/group");
  }

  static async GetById(groupId: string): Promise<any> {
    const encodedId = encodeURIComponent(groupId);
    return ApiHandler(baseURL).get(`/group/${encodedId}`);
  }

  static async Update(payload: UpdateGroupPayload): Promise<any> {
    return ApiHandler(baseURL).put(`/group`, payload);
  }
}
